/* eslint max-statements: 0 */
import { selectConsentDetailsForIsoCode } from 'shared/consentsUtil'

export default function validate (values, props) {
  const {
    consentMatrix,
  } = props

  const consent = selectConsentDetailsForIsoCode(consentMatrix, values.gdpr_iso_code)
  const consentStandard = consent && consent.standard

  const errors = {}
  const nameRegex = /^[-\w '.]{1,30}$/
  const emailRegex = /[^\s]+@[^\s]+\.[^\s]+/
  const passwordRegex = /^[\s\S]{6,30}$/

  if (!values.firstName) {
    errors.firstName = 'required'
  } else if (!values.firstName.match(nameRegex)) {
    errors.firstName = 'name/pattern'
  }

  if (!values.lastName) {
    errors.lastName = 'required'
  } else if (!values.lastName.match(nameRegex)) {
    errors.lastName = 'name/pattern'
  }

  if (!values.email) {
    errors.email = 'required'
  } else if (!values.email.match(emailRegex)) {
    errors.email = 'email/pattern'
  }

  if (!values.password) {
    errors.password = 'required'
  }

  if (values.password && !values.password.match(passwordRegex)) {
    errors.password = 'password/pattern'
  }

  if (!values.day || !values.month || !values.year) {
    errors.birthdate = 'required'
  }

  if (!values.day) {
    errors.day = 'required'
  }

  if (!values.month) {
    errors.month = 'required'
  }

  if (!values.year) {
    errors.year = 'required'
  }

  if (!values.gender) {
    errors.gender = 'required'
  }

  if (!values.gdpr_iso_code) {
    errors.gdpr_iso_code = 'required'
  }

  if (consentStandard === 'EU1' || consentStandard === 'EU2') {
    if (!values.terms) { errors.terms = 'required' }
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/components/auth/signup/validate.js